// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__wysuj","content":"NotFound_content__TunbN","title":"NotFound_title__LCM7P","subtitle":"NotFound_subtitle__oXRTi"};